import React from 'react';
import {
  CardAvatar,
  CardHeader,
  VerticalSpace,
} from '@brokerbay/design-components';
import { MailFilled } from '@ant-design/icons';
import { Text, Link } from 'components';

interface EmailSentViewProps {
  loginUrl?: string;
}

const EmailSentView = ({ loginUrl }: EmailSentViewProps) => (
  <VerticalSpace>
    <CardHeader
      title="Email sent!"
      icon={<CardAvatar icon={MailFilled} theme="success" />}
    />
    <Text textAlign="center">
      A member of our sales team will be in touch with you shortly.
    </Text>
    {loginUrl && (
      <Link block textAlign="center" href={loginUrl}>
        Return to log in
      </Link>
    )}
  </VerticalSpace>
);

export default EmailSentView;
